<template>
  <div class="divisao-container">
    <h1 class="title">DIVISÕES</h1>

    <div class="section-all">
      <div class="section">
        <img src="../assets/Bomba ZN.png" alt="Ícone Bombas" class="picture" />
        <h2 class="subtitle">BOMBAS</h2>
        <p class="text">Bombas Centrífugas Químicas Horizontais e Verticais.</p>
        <a href="/Bombas"><button class="button">
            <img src="../assets/Vector76.svg" alt="Ícone Seta" class="icon-seta" />Catálogo
          </button></a>
      </div>

      <div class="section">
        <img src="../assets/servicos/valvula_vg37.jpg" alt="Ícone Válvula" class="picture" />
        <h2 class="subtitle">VÁLVULAS</h2>
        <p class="text">Válvulas Globo, Gaveta, Cunha e Borboleta.</p>
        <a href="/Valvulas"><button class="button">
            <img src="../assets/Vector76.svg" alt="Ícone Seta" class="icon-seta" />Catálogo
          </button></a>
      </div>

      <div class="section">
        <img src="../assets/service_zecon.png" alt="Ícone Serviços" class="picture" />
        <h2 class="subtitle">SERVIÇOS</h2>
        <p class="text">
          Manutenção e Sobressalentes em Bombas Centrifugas Magnéticas.
        </p>
        <a href="#servicos"><button class="button">
            <img src="../assets/Vector76.svg" alt="Ícone Seta" class="icon-seta" />Saiba Mais
          </button></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Divisoes",
};
</script>

<style scoped>
.divisao-container {
  background-color: #f5f5f5;
}

.section-all {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 6.4vw;
  padding: 0 0 8vh 0;
}

.section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 510px;
  margin: 4vh 1vw 0 1vw;
}

.title {
  color: #343333;
  font-family: "Montserrat", sans-serif;
  font-size: 3em;
  font-weight: 300;
  text-align: center;
  position: relative;
  padding: 4vh 0 0 0;
}

.title::after {
  content: "";
  display: block;
  width: 2.4em;
  height: 0.09em;
  background-color: #343333cc;
  opacity: 0.8;
  border-radius: 30px;
  margin: 1vh 0 0 0;
  position: relative;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.picture {
  height: 32vh;
  width: auto;
  border-radius: 2px;
  box-shadow: 4px 4px 6px #00000099;
}

.subtitle {
  color: #343333;
  font-family: "Montserrat", sans-serif;
  font-size: 2em;
  font-weight: 400;
  text-align: center;
  margin: 2vh 0 3vh;
}

.subtitle::after {
  content: "";
  display: block;
  width: 1.2em;
  height: 0.15em;
  background-color: #ffc737;
  opacity: 0.8;
  border-radius: 30px;
  position: relative;
  bottom: 0;
}

.text {
  color: #000000;
  font-family: "Montserrat", sans-serif;
  font-size: 1.3em;
  font-weight: 400;
  line-height: 1.3em;
  text-align: center;
  margin: 0.5em 0 2em 0;
  width: 400px;
}

.button {
  color: #16181a;
  background-color: #ffc737;
  font-family: "Montserrat", sans-serif;
  font-size: 1.8em;
  font-weight: 400;
  text-align: center;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.2em 0.2em 0.2em 1.1em;
  box-shadow: 4px 4px 6px #00000080;
}

.icon-seta {
  width: 1em;
  height: 0.8em;
  margin-left: 0.5em;
  order: 1;
}

@media screen and (max-width: 1300px) {
  .picture {
    height: 25vh;
    width: auto;
  }

  .section {
    flex: 3;
    margin: 4vh 1vw 0 1vw;
  }

  .text {
    font-size: 1.1em;
    width: 300px
  }
}

@media screen and (max-width: 992px) {
  .section-all {
    flex-direction: column;
    margin: 0 6.4vw;
    padding: 0 0 4vh 0;
  }

  .section {
    margin: 6vh 1vw 6vh 1vw;
  }

  .subtitle {
    font-size: 2em;
  }

  .text {
    font-size: 1.15em;
    width: 330px;
  }
}
</style>
